import { SVGProps } from 'react'

export const RedoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      clipRule='evenodd'
      d='M14.669 3.497a.7.7 0 01-.014 1.175l-3.581 2.263A.7.7 0 0110 6.344V4.75H6.875a4.375 4.375 0 100 8.75h3.375a.75.75 0 010 1.5H6.875a5.875 5.875 0 110-11.75H10V1.701a.7.7 0 011.087-.583l3.582 2.379z'
      fillRule='evenodd'
    />
  </svg>
)
